// A CSS-only tooltip.
//
// react-bootstrap's <Tooltip> emits .tooltip / .tooltip-inner /
// .tooltip-arrow, which Bootstrap's stylesheet used to draw -- this
// project deleted it, so those render as bare text floating over the
// page. This one is drawn by ::after/::before in the trainer area's
// stylesheet, costs no JavaScript, and cannot be left behind when the
// row it belongs to unmounts.
const Tip = ({ label, children, className = "" }) => (
  <span className={`pg-tip ${className}`.trim()} data-tip={label}>
    {children}
  </span>
);

export default Tip;
